"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TrackLimitNumbers = function (props) {
    var hasSubmissionInfo = props.createableDebts !== null && props.periodEnd !== '';
    return (React.createElement("div", { className: "track-limit-numbers" },
        React.createElement("span", { className: "limit-sub-title" }, "You are tracking: "),
        React.createElement("div", { className: "limit-title" },
            props.activeDebts || 0,
            " ",
            props.activeDebts === 1 ? 'Debt' : 'Debts'),
        hasSubmissionInfo && (React.createElement("div", null,
            "You can submit ",
            props.createableDebts,
            " debts before ",
            props.periodEnd))));
};
exports.default = TrackLimitNumbers;
